import { AssetTypeReadExternalAllowedTaskTypes, TaskTypeGroupListExternal } from '@askporter/grieg-types';
import { GroupedTaskTypes } from '../types';

type AllowedGroupedTaskTypes = Array<GroupedTaskTypes>;

/**
 * Returns grouped task types that are permitted for a given asset, enriches the grouped an isGroup flag and the default
 * indicator
 * @param allTaskTypeGroups - full list of task types grouped (as provided by grieg)
 * @param allowedTaskTypes - list of allowed task types, retrieved from the asset type
 */
export const groupAllowedTaskTypes = (
  allTaskTypeGroups: TaskTypeGroupListExternal['taskTypeGroups'],
  allowedTaskTypes: Array<AssetTypeReadExternalAllowedTaskTypes>,
): AllowedGroupedTaskTypes => {
  const allowedTaskTypeUids = allowedTaskTypes.map(({ taskType }) => taskType.uid);
  const taskTypeGroups: AllowedGroupedTaskTypes = [];

  allTaskTypeGroups.forEach((group) => {
    const allowedTypes = group.taskTypes
      // establish the list of allowed types from within this group
      .filter((type) => allowedTaskTypeUids.includes(type.uid))
      // get the default status, if it's missing then its considered false https://github.com/askporter/front-end/issues/627#issuecomment-922771045
      .map((type) => ({
        ...type,
        default: allowedTaskTypes.find(({ taskType }) => type.uid === taskType.uid)?.default || false,
      }));

    if (allowedTypes?.length > 0)
      taskTypeGroups.push({
        ...group,
        isGroup: allowedTypes?.length > 1 ? true : false,
        allDefault: allowedTypes.every((type) => type.default === true),
        taskTypes: allowedTypes,
      });
  });

  return taskTypeGroups;
};
